import script from "./ServiceDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceDetail.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceDetail.vue?vue&type=style&index=0&id=e0c80fb2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0c80fb2"]])

export default __exports__